<template>
    <div class="footer-area black-bg-2 pt-70">

        <div class="footer-top-area pb-18">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="footer-widget mb-40">
                            <div class="footer-title mb-22">
                                <h4>Information</h4>
                            </div>
                            <div class="footer-content">
                                <ul>
                                    <li><router-link to="/about">About Us</router-link></li>
                                    <li><router-link to="/privacy">Privacy Policy</router-link></li>
                                    <li><router-link to="/terms">Terms and Conditions</router-link></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="footer-widget mb-40">
                            <div class="footer-title mb-22">
                                <h4>Events</h4>
                            </div>
                            <div class="footer-content">
                                <ul>
                                    <li><router-link to="/start-selling">Create your event</router-link></li>
																		<li><router-link to="/tickets">My Tickets</router-link></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="footer-widget mb-40">
                            <div class="footer-title mb-22">
                                <h4>Get in touch</h4>
                            </div>
                            <div class="footer-contact">
                                <ul>
                                    <li>Telephone Enquiry: 0729394730</li>
                                    <li>Email: <a href="#">info@ticketmojo.co.ke</a></li>
                                </ul>
                            </div>
                            <div class="mt-35 footer-title mb-22">
                                <h4>Get in touch</h4>
                            </div>
                            <div class="footer-time">
                                <ul>
                                    <li>Open:  <span>8:00 AM</span> - Close: <span>6:00 PM</span></li>
                                    <li>Everyday</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer-bottom-area border-top-4">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-7">
                        <div class="copyright">
                            <p>&copy; <a href="#">TicketMojo</a> All Rights Reserved.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-5">
                        <div class="footer-social">
                            <ul>
                                <li><a href="https://twitter.com/ticketmojoke"><i class="ion-social-twitter"></i></a></li>
                                <li><a href="https://instagram.com/ticketmojokenya"><i class="ion-social-instagram-outline"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
    export default {
        name: 'Footer'
    }
</script>